// extracted by mini-css-extract-plugin
module.exports = {"petCardsContainer":"PetCardsContainer_petCardsContainer__1fNuT","reverseBackground":"PetCardsContainer_reverseBackground__fbibl"};